export const device = {

    mobile: `screen and (max-width: 830px)`,
    // tablet: `only screen and (min-width: 768px)`
}